import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Label} from '@cred/react-label'
import {FormField} from '@cred/react-form-field'
import {isMobile, isTablet} from '@cred/shared/utils'
import {Tooltip} from '@cred/react-tooltip'
import NumberFormat from 'react-number-format'
import styles from './styles.module.scss'

class InputComponent extends Component {
  static propTypes = {
    input: PropTypes.object,
    label: PropTypes.string,
    meta: PropTypes.object,
    small: PropTypes.bool,
    id: PropTypes.string,
    getInputRef: PropTypes.func,
    decimalScale: PropTypes.number,
    fixedDecimalScale: PropTypes.bool,
    placeholder: PropTypes.string,
    forceOpenTooltip: PropTypes.bool,
    customInputProps: PropTypes.object,
    type: PropTypes.oneOf(['text', 'tel']),
  }

  static defaultProps = {
    input: {},
    label: '',
    meta: {},
    small: false,
    id: '',
    getInputRef: () => {},
    decimalScale: 2,
	  fixedDecimalScale: false,
	  placeholder: '%',
    forceOpenTooltip: false,
    customInputProps: {},
	  type: 'text',
  }

  componentDidMount() {
    if (this.inputRef && this.props.forceOpenTooltip) {
      this.inputRef.click()
    }
  }

  isAllowed = floatValue => floatValue === undefined || floatValue <= 100

  render() {
    const {
        input,
        label,
        meta,
        small,
        id,
        getInputRef,
        decimalScale,
        fixedDecimalScale,
        placeholder,
        forceOpenTooltip,
        customInputProps,
        type,
      } = this.props,
      inputWithCustomProps = Object.assign({}, input, customInputProps)

    return (
      <FormField
        status={meta}
        error={meta.error}
        signRightPosition
        small={small}
        value={inputWithCustomProps.value}
        label={label}
      >
        <div
          className={styles.inputContainer}
          data-tip
          data-effect="solid"
          data-place={isTablet() ? 'bottom' : 'right'}
          data-for={inputWithCustomProps.name}
          ref={elem => this.inputRef = elem}
        >
          <div className={[styles.input, small ? styles.smallInput : ''].join(' ')}>
            <NumberFormat
              isAllowed={({floatValue}) => this.isAllowed(floatValue)}
              decimalScale={decimalScale}
              allowNegative={false}
              type={type}
              placeholder={placeholder}
              id={id || inputWithCustomProps.name}
              getInputRef={getInputRef}
              fixedDecimalScale={fixedDecimalScale}
              {...inputWithCustomProps}
            />
          </div>
          <div className={[styles.sign, small ? styles.smallSign : ''].join(' ')}>%</div>
        </div>
        <Label htmlFor={id || inputWithCustomProps.name}>{label}</Label>
        {!isMobile() &&
          <Tooltip
            id={inputWithCustomProps.name}
            pinned
            forceOpenTooltip={forceOpenTooltip}
            showTooltipOnce
            showClosingX
            tooltipType="dark"
          >
            <div className={styles.tooltipWrapper}>
              Estimate your APR for <span>each loan</span>, and we'll show you
              how much you can save when comparing rates from our lenders.
            </div>
          </Tooltip>
        }
      </FormField>
    )
  }
}

export {InputComponent}
